<script src="https://polyfill.io/v3/polyfill.min.js?flags=gated&features=IntersectionObserver,requestAnimationFrame"></script>
<script>
export default {
    props: {
        observeOnce: {
            type: Boolean,
            default: false
        },
        observeScroll: {
            type: Boolean,
            default: false
        },
        threshold: {
            type: [Number, Array],
            default: 0
        },
        rootMargin: {
            type: [Number, String, Array],
            default: 0
        },
        event: {
            type: Object
        },
        modalData: {
            type: Object
        }
    },
    data: () => ({
        isDynamic: false,
        isInView: false,
        isAtTarget: false,
        isObserved: false,
        isTicking: false,
        aFrame: undefined
    }),
    computed: {
        options() {
            let rootMargin = this.rootMargin;
            if (typeof this.rootMargin === 'number') {
                rootMargin = `${this.rootMargin}px`;
            } else if (Array.isArray(this.rootMargin)) {
                rootMargin = this.rootMargin.join(' ');
            }
            return {
                rootMargin: rootMargin,
                threshold: this.threshold
            }
        }
    },
    mounted() {
        if (!this.isDynamic) {
            this.initWatchScroll();
        }
    },

    /**
     * Help GC by removing listeners, cancelling animations/timeouts and
     * disconnecting `IntersectionObserver`
     */
    beforeDestroy() {
        this.io.disconnect();
        if (this.observeScroll && this.isObserved) {
            this.isAtTarget = false;
            window.removeEventListener('scroll', this.scrollHandler);
            if (this.aFrame) {
                window.cancelAnimationFrame(this.aFrame);
            }
        }
    },
    methods: {

        /**
         * Initiates the IntersectionObserver instance
         * @param {{rootMargin: String, threshold: Number}} [options] - Optional options to pass
         */
        initWatchScroll(options) {
            // Merge options if passed
            const opts = options ? {...this.options, ...options} : this.options;
            this.io = new IntersectionObserver(this.observeHandler, opts);
            this.io.observe(this.$el);
        },

        /**
         * Handles the debounced calls as `ticks` from `requestAnimationFrame`
         */
        tickHandler() {
            const top = this.$el.getBoundingClientRect().top;
            this.$emit('watch-scroll-tick', top);
            this.isTicking = false;
        },

        /**
         * Handles the scroll event
         */
        scrollHandler() {
            if (!this.isTicking) {
                this.aFrame = window.requestAnimationFrame(this.tickHandler);
            }
            this.isTicking = true;
        },

        /**
         * Handles the IntersectionObserver callback
         * @param {[IntersectionObserverEntry]} entries - IntersectionObserverEntry objects
         * @param {IntersectionObserver} observer - The observer
         */
        observeHandler(entries, observer) {
            this.isInView = !(entries[0].intersectionRatio <= 0);
            this.isAtTarget = entries[0].isIntersecting;
            if (this.event && (this.isInView && this.isAtTarget)) {
                this.$eventsBus.$emit(this.event.name, this.event.data);
            }
            if (this.observeOnce && this.isInView) {
                this.io.unobserve(this.$el);
            }
            if (this.observeScroll) {
                if (!this.isObserved && this.isInView) {
                    this.isObserved = true;
                    window.addEventListener('scroll', this.scrollHandler, false);
                } else if (this.isObserved && !this.isInView) {
                    this.isObserved = false;
                    this.isAtTarget = false;
                    window.removeEventListener('scroll', this.scrollHandler);
                }
            }
        }
    },
    render() {
        return this.$slots.default[0];
    }
};
</script>
